import { render, staticRenderFns } from "./MarvelousBio.vue?vue&type=template&id=6d53c698&scoped=true&"
import script from "./MarvelousBio.vue?vue&type=script&lang=ts&"
export * from "./MarvelousBio.vue?vue&type=script&lang=ts&"
import style0 from "./MarvelousBio.vue?vue&type=style&index=0&id=6d53c698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53c698",
  null
  
)

export default component.exports